import { Popover, Transition } from "@headlessui/react";
import { setOpenNavbar } from "../../../redux/openNavbarSlice";
import Badge from "components/molecules/Badge";
import { menuNav } from "constants/menu";
import useColorMode from "hooks/useColorMode";
import { useOnClickOutside } from "hooks/useOnClickOutside";
import { useCallback, useContext, useEffect, useRef } from "react";
import { useState } from "react";
import { BsMoonFill, BsSunFill } from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoConstructOutline, IoNotificationsOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { LogoutByAdmin, getData, isAuth } from "actions";
import { AuthContext } from "context/AuthContext";
import {
  API_URL_notification,
  API_URL_notificationUpdate,
  baseurl,
} from "constants/api";
import { notificationReducers } from "redux/notificationSlice";
import { FaTicketAlt } from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { notificationUpdateReducers } from "redux/notificationUpdateSlice";
import { ModalNotificationUpdate } from "components";

const Navbar = ({ sideOpen, setSideOpen, admin, setAdmin }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [colorMode, setColorMode] = useColorMode();
  const refSubMenu = useRef();
  const notificationRef = useRef();
  const dispatch = useDispatch();

  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [subMenuActive, setSubMenuActive] = useState("");
  const [isNotification, SetIsNotification] = useState(false);
  const [isNotificationUpdated, SetIsNotificationUpdated] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [itemModal, setItemModal] = useState(false);

  const { datauser } = useContext(AuthContext);
  const UserAuth = isAuth();

  const { getNotificationResult, getNotificationUpdateResult } = useSelector(
    (state) => ({
      getNotificationResult: state.notification.getNotificationResult,
      getNotificationUpdateResult:
        state.notificationUpdate.getNotificationUpdateResult,
    })
  );

  const getNotification = useCallback(
    async (params) => {
      getData(
        API_URL_notification,
        params,
        { dispatch, redux: notificationReducers },
        "GET_NOTIFICATION"
      );
    },
    [dispatch]
  );
  const getNotificationUpdate = useCallback(
    async (params) => {
      getData(
        API_URL_notificationUpdate,
        params,
        { dispatch, redux: notificationUpdateReducers },
        "GET_NOTIFICATIONUPDATE"
      );
    },
    [dispatch]
  );

  const handleNavigateHistoryUpdate = () => {
    navigate("/notificationsupdate");
  };

  const handleOpenNotification = () => {
    SetIsNotification(!isNotification);
    SetIsNotificationUpdated(false);
  };

  const handleOpenNotificationUpdated = () => {
    SetIsNotificationUpdated(!isNotificationUpdated);
    SetIsNotification(false);
  };

  useOnClickOutside(notificationRef, () => {
    SetIsNotification(false);
    SetIsNotificationUpdated(false);
  });

  useOnClickOutside(refSubMenu, () => {
    setSubMenuOpen(false);
    setSubMenuActive(false);
  });

  const handleDoubleClick = () => {
    setSubMenuOpen(false);
    setSubMenuActive(false);
  };

  const handleLogout = () => {
    LogoutByAdmin();
  };

  const deleteAllNotificationTicket = () => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      url: baseurl + "/master/notification/readall",
    })
      .then((response) => {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((error) => {
        console.log(error);
      });
    getNotification(`/?user_id=${UserAuth.user_id}`);
    getNotification(`/?user_id=${UserAuth.user_id}`);
  };

  const deleteAllNotificationUpdate = () => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      url:
        baseurl +
        `/master/notificationupdate/readall/?user_id=${UserAuth.user_id}`,
    })
      .then((response) => {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((error) => {
        console.log(error);
      });
    getNotificationUpdate(`/unread_count/?user_id=${UserAuth.user_id}`);
    getNotificationUpdate(`/unread_count/?user_id=${UserAuth.user_id}`);
  };

  const onReadNotificationTicket = (item) => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      url: baseurl + "/master/notification/read/" + item.id + "/",
    })
      .then((response) => {
        console.log(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });

    getNotification(`/?user_id=${UserAuth.user_id}`);
    getNotification(`/?user_id=${UserAuth.user_id}`);
    navigate("tickets/ticketdetail/", { state: { id: item.ticket } });
  };

  const onReadNotificationUpdate = (item) => {
    setIsOpen(true);
    setItemModal(item);
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      url: baseurl + "/master/notificationupdate/read/" + item.id + "/",
    })
      .then((response) => {
        console.log(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });

    getNotificationUpdate(`/unread_count/?user_id=${UserAuth.user_id}`);
    getNotificationUpdate(`/unread_count/?user_id=${UserAuth.user_id}`);
    // navigate("tickets/ticketdetail/", { state: { id: item.ticket } });
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    setSubMenuOpen(false);
    setSubMenuActive(false);
  }, [admin]);

  useEffect(() => {
    dispatch(setOpenNavbar(subMenuActive));
  }, [subMenuActive]);

  useEffect(() => {
    getNotification(`/?user_id=${UserAuth.user_id}`);
    getNotificationUpdate(`/unread_count/?user_id=${UserAuth.user_id}`);
  }, []);

  return (
    <>
      <nav
        className={`px-6 py-4 h-16 dark:bg-neutral-800 flex justify-between z-20 sticky top-0 w-full text-white shadow ${
          admin
            ? "bg-gradient-to-r from-sky-600 to-yellow-800 dark:from-sky-900 dark:to-yellow-800 "
            : "bg-gradient-to-r from-sky-600 to-black dark:from-sky-900 dark:to-black"
        }`}
      >
        <div className="flex gap-6 items-center">
          {/* Open Side */}
          <button onClick={() => setSideOpen(!sideOpen)}>
            <GiHamburgerMenu />
          </button>

          {/* Admin */}
          <div className="h-full gap-4 hidden sm:flex ">
            {/* Menu Nav */}
            {!admin &&
              menuNav.map((item, index) => {
                if (item.sub.length > 0) {
                  return (
                    <button
                      key={index}
                      onClick={() => {
                        setSubMenuOpen(item);
                        setSubMenuActive(item.name);
                      }}
                      className={`hover:text-sky-400  dark:hover:text-sky-400 text-sm
                      ${item.hidden === true ? "hidden" : ""}
                       ${
                         pathname.split("/")?.[1] === item.name
                           ? "text-sky-400"
                           : "text-white dark:text-neutral"
                       } `}
                    >
                      {item.title}
                    </button>
                  );
                } else {
                  return (
                    <NavLink
                      className="flex items-center"
                      to={item.path}
                      key={index}
                    >
                      {({ isActive }) => (
                        <div
                          className={`text-sm hover:text-sky-400 dark:hover:text-sky-400 ${
                            isActive
                              ? "text-sky-400"
                              : "text-white dark:text-neutral"
                          } ${item.hidden ? "hidden" : ""}`}
                        >
                          {item.title}
                        </div>
                      )}
                    </NavLink>
                  );
                }
              })}
          </div>
        </div>

        <div ref={notificationRef} className="flex items-center gap-6">
          {/* Button Admin */}
          {datauser &&
            datauser.group_permissions.includes("access_menu_admin") && (
              <Link
                to={
                  admin ? `/dashboard/agent` : `/administrator/dashboard/admin`
                }
              >
                <button
                  onClick={() => setAdmin(!admin)}
                  className="dark:bg-dark-700 text-white dark:text-neutral text-sm hover:text-sky-400"
                >
                  {admin ? "Go to Agents" : "Go to Admin"}
                </button>
              </Link>
            )}

          {/* Color Mode */}
          <button
            className="p-4  bg-sky-800 dark:bg-neutral-700 rounded-full relative overflow-hidden"
            onClick={() =>
              setColorMode(colorMode === "light" ? "dark" : "light")
            }
          >
            <BsMoonFill
              className={`transition-all absolute -mt-2 top-1/2 -ml-2 left-1/2 ${
                colorMode === "light" ? " top-16" : ""
              }`}
            />
            <BsSunFill
              className={`transition-all absolute -mt-2 top-1/2 -ml-2 left-1/2 ${
                colorMode === "dark" ? " top-16" : ""
              }`}
            />
          </button>

          {/*Notification Updates */}
          <button
            type="button"
            className={`relative z-50 p-2 bg-sky-800 dark:bg-neutral-700 rounded-full `}
            onClick={handleOpenNotificationUpdated}
          >
            <IoConstructOutline />
            <Badge
              text={
                getNotificationUpdateResult.count_update &&
                getNotificationUpdateResult.count_update > 0
                  ? getNotificationUpdateResult.count_update
                  : ""
              }
              addclass="absolute bg-green-500 left-7 bottom-2 text-white"
            />
            {isNotificationUpdated && (
              <ul className="list-none cursor-default bg-white dark:bg-neutral-700 dark:text-white text-gray-800 text-center absolute top-8 right-0 mt-4 md:mr-4 border border-gray-300 p-4 rounded shadow max-h-96 w-64 md:w-96 overflow-y-auto">
                <li className=" pb-2 flex justify-around">
                  You Have{" "}
                  {getNotificationUpdateResult.count_update &&
                  getNotificationUpdateResult.count_update
                    ? getNotificationUpdateResult.count_update
                    : 0}{" "}
                  Notifications Update{" "}
                  {getNotificationUpdateResult.notifications &&
                    getNotificationUpdateResult.notifications.length > 0 && (
                      <a
                        onClick={() => deleteAllNotificationUpdate()}
                        className="text-blue-500 hover:text-blue-800"
                      >
                        Mark all as read
                      </a>
                    )}
                </li>
                <hr className="mb-4" />
                {getNotificationUpdateResult.notifications &&
                  getNotificationUpdateResult.notifications.map(
                    (item, index) => (
                      <>
                        <li key={index}>
                          <button
                            onClick={() => onReadNotificationUpdate(item)}
                            className="hover:text-blue-500"
                          >
                            <div className="flex items-center justify-center mb-1 font-bold">
                              {item.title}
                            </div>
                          </button>
                        </li>
                        <hr className="mb-4 border-dashed border-t-2 border-t-gray-300" />
                      </>
                    )
                  )}
                <li id="footer" className="py-1 mt-4">
                  <button
                    type="button"
                    onClick={() => {
                      handleNavigateHistoryUpdate();
                    }}
                    className="px-20 py-2 text-black bg-purple-300 hover:bg-purple-400 rounded"
                  >
                    History Update
                  </button>
                </li>
              </ul>
            )}
          </button>

          {/* Notifications Ticket*/}
          <button
            type="button"
            className={`relative p-2 bg-sky-800 dark:bg-neutral-700 rounded-full ${
              isNotification && "bg-sky-300 dark:bg-sky-700"
            }`}
            onClick={handleOpenNotification}
          >
            <IoNotificationsOutline />
            <Badge
              text={
                getNotificationResult && getNotificationResult.count_unread > 0
                  ? getNotificationResult.count_unread
                  : ""
              }
              addclass="absolute bg-green-500 left-7 bottom-2 text-white"
            />
            {isNotification && (
              <ul className="list-none cursor-default bg-white dark:bg-neutral-700 text-gray-800 dark:text-white text-center absolute top-12 right-0 border border-gray-300 p-4 rounded shadow max-h-96 w-80 md:w-96 overflow-y-auto">
                <li className=" pb-2 flex justify-around ">
                  You Have{" "}
                  {getNotificationResult && getNotificationResult.count_unread
                    ? getNotificationResult.count_unread
                    : 0}{" "}
                  Notifications Ticket{" "}
                  {getNotificationResult &&
                    getNotificationResult.notifications.length > 0 && (
                      <a
                        onClick={() => deleteAllNotificationTicket()}
                        className="text-blue-500 hover:text-blue-800"
                      >
                        Mark all as read
                      </a>
                    )}
                </li>
                <hr className="mb-4" />
                {getNotificationResult &&
                  getNotificationResult.notifications.map((item, index) => (
                    <li key={index}>
                      <button
                        onClick={() => onReadNotificationTicket(item)}
                        className="hover:text-blue-500"
                      >
                        <div className="flex items-center justify-center mb-1">
                          <FaTicketAlt className="text-sky-600 dark:text-sky-300 text-2xl mr-2" />
                          {item.message}
                        </div>
                      </button>
                    </li>
                  ))}
                <li id="footer" className="py-1 mt-4">
                  {getNotificationResult &&
                    getNotificationResult.notifications.length > 0 && (
                      <Link
                        to="/notifications"
                        className="px-20 py-2 text-black bg-sky-300 hover:bg-sky-400 rounded "
                      >
                        View All
                      </Link>
                    )}
                </li>
              </ul>
            )}
          </button>

          {/* Profiles */}
          <Popover as={"div"} className="relative text-gray-900">
            <Popover.Button className="flex items-center gap-2 outline-none">
              <div className="h-8 w-8 rounded-full cursor-pointer overflow-hidden">
                <img
                  className="object-cover h-full w-full"
                  src={datauser.profile_pic ?? datauser.avatar}
                  alt="user"
                />
              </div>
            </Popover.Button>
            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <Popover.Panel className="absolute w-max min-w-[170px] flex flex-col right-3 top-6 rounded-sm shadow-lg bg-white text-base-800 overflow-hidden">
                <div className="px-2 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link
                    to={"/dashboard/profile/informationprofile"}
                    state={{ datauser }}
                  >
                    <div className="text-xs font-medium">
                      {datauser && datauser.email}
                    </div>
                    <div className="text-[10px]">
                      {datauser && datauser.first_name}{" "}
                      {datauser && datauser.last_name}
                    </div>
                  </Link>
                </div>
                <div className="flex flex-col">
                  <button
                    onClick={() => handleLogout()}
                    className="text-xs py-2 px-2 text-left hover:bg-primary-700 hover:text-white transition-all"
                  >
                    Keluar
                  </button>
                </div>
              </Popover.Panel>
            </Transition>
          </Popover>
        </div>
      </nav>

      {/* Sub Menu */}
      <div
        onDoubleClick={handleDoubleClick}
        ref={refSubMenu}
        className={` bg-neutral dark:bg-neutral-800 flex justify-between z-10 sticky top-0 w-full shadow transition-all ${
          subMenuOpen ? "h-14 px-6 py-3" : "h-0"
        }`}
      >
        <div className="flex gap-4 items-center">
          {subMenuOpen &&
            subMenuOpen?.sub?.map((item, itemIdx) => (
              <NavLink to={`${subMenuOpen.path}/${item.path}`} key={itemIdx}>
                {({ isActive }) => (
                  <div
                    className={`text-sm  hover:text-sky-400 dark:hover:text-sky-400 ${
                      isActive
                        ? "text-sky-400"
                        : "text-neutral-800 dark:text-neutral"
                    } ${item.hidden ? "hidden" : ""}`}
                  >
                    {item.title}
                  </div>
                )}
              </NavLink>
            ))}
        </div>
      </div>
      <ModalNotificationUpdate
        isOpen={isOpen}
        onClose={closeModal}
        item={itemModal}
      />
      <ToastContainer />
    </>
  );
};

export default Navbar;
